//manage-employee.js
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isAuthenticated } from "../../../auth";
import { getAllBranches, getBranch, getBranchCount } from "../../gyms/helper/api";
// import config from "../../../config";
import client from "../../../clients";
import { formatDate, formatDateTime, startLoader, stopLoader, validatePhoneNumber } from "../../../lib/utils";
import Toast from "../../../lib/toast";
import _ from 'lodash';
import '../../../features/employees/style.scss';
import flatpickr from "flatpickr";
import { getRoles } from "../../../core/helper/RoleAPiCall";
import { createUserV2, updateUserV2 } from "../helper/api";

const ManageEmployeeModal = (props) => {

  const history = useHistory();
  const location = useLocation();
  const [isWpAdmin,setWpAdmin] = useState(false)
  const [roles,setRoles] = useState([])
  const [isButtonLock, setButtonLock] = useState(false);
  const path = location.pathname;
  const [branchSearchKey,setBranchSearchKey] = useState("");
  var [pageNo,setPageNo] = useState(1);
  var pageSize = 14;
  var [pageCount, setPageCount] = useState({
    gym: 0,
    branch: 1
  });
  const [currentElementId, setCurrentElementId] = useState("");
  const [workoutGymTypeOpenDropdown, setWorkoutGymTypeOpenDropdown] = useState(false);
  const [isNewUser, setNewUser] = useState(false);
  const [isUserEditEnabled, setUserEditEnabled] = useState(true);
  const [addNewUser, setAddNewUser] = useState({
    name: "",
    gender: "",
    dob:"",
    email: "",
    phone: "",
    gymID: "",
    branchID: "",
    password:"",
    maritalStatus: "",
    anniversaryDate:"",
    anniversaryDateString:"",
    profile: [],
    role: []
  });

  const userProfile = {
    gymInfo: "",
    userRole: []
  };

  var [total, setTotal] = useState({
    branch: 0,
    gym: 0
  });
  const [foundUser, setFoundUser] = useState('');
  const [isBranchSpinnerLoader, setBranchSpinnerLoader] = useState(false);

  const { user, token } = isAuthenticated();

  const [allBranches, setAllBranches] = useState([]);
  const birthDateRef = useRef(null);
  const anniversaryDateRef = useRef(null);

  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const handleWpAdminChange = (event) => { 
    setWpAdmin(!isWpAdmin); 
  }

  const handleSelectProfile = (branch,index) =>{
    if(addNewUser.profile.findIndex(d=>d.gymInfo._id == branch._id) != -1){
      return new Toast({type:'warning',message:"Gym already selected",duration:3000});
    }
    setAddNewUser(oldstate=>{
        if(!(oldstate.profile[index].gymInfo && oldstate.profile[index].gymInfo._id == branch._id)){
          oldstate.profile[index].gymInfo=branch;
          oldstate.profile[index].userRole=[];
        }
      return {...oldstate};
    })
    setCurrentElementId("")
  }

  const handleSearchBranch = event =>{
    setBranchSearchKey(event.target.value);
  }


  const handleAddProfile = () => {
    setAddNewUser(prev => ({
      ...prev,
      profile: [...prev.profile, userProfile]
    }));
  }

  const handleDeleteProfile = (indexToDelete) => {
    setAddNewUser(prev => ({
      ...prev,
      profile: prev.profile.filter((_, index) => index !== indexToDelete)
    }));
  }

  const getSelectedGender = (gender) => {
    setAddNewUser(prev => ({
      ...prev,
      gender: gender
    }));
    setCurrentElementId("")
  }

  const openDateAndTime = () => {

    if (!birthDateRef.current) return;

    const birthdayPicker = flatpickr(birthDateRef.current, {
      disableMobile: true,
      dateFormat: "Y-m-d",
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setAddNewUser(prev => ({
          ...prev,
          dob: istDate
        }));
      }
    });
  
    return () => {
      birthdayPicker.destroy();
    }
  }

  const openAnniversaryDateAndTime = () => {

    if (!anniversaryDateRef.current) return;

    const anniversaryDatePicker = flatpickr(anniversaryDateRef.current, {
      disableMobile: true,
      dateFormat: "Y-m-d",
      onChange: ([date]) => {
        const istDate = date.toLocaleDateString('en-CA', {
          timeZone: 'Asia/Kolkata'
        });
        setAddNewUser(prev => ({
          ...prev,
          anniversaryDate: istDate
        }));
      }
    });
  
    return () => {
      anniversaryDatePicker.destroy();
    }
  }

  const handleMaritalStatus = (status) => {
    setAddNewUser(prev => ({
      ...prev,
      maritalStatus: status
    }));
  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible)
  } 
 
  useEffect(()=>{
    checkDataField();
  },[addNewUser,isWpAdmin]);


  const checkDataField = () => {

    let unlockField=true;


  

    if(addNewUser.profile.length){
      let isAllProfileSelected = true;
      addNewUser.profile.forEach(profile => {
        if((props.isUserLookup?profile.gymInfo:true) && profile.userRole.length == 0){
          isAllProfileSelected = false;
        }
      })
      if(!isAllProfileSelected){
        unlockField = false;
      }else{
        unlockField = true;
      }
    }

    if(props.isEdit && isWpAdmin){
      unlockField=true;
    }


    if (addNewUser.name.length>3 && validatePhoneNumber(addNewUser.phone) && unlockField) {
      setButtonLock(false)
    } else {
      setButtonLock(true);
    }
  }

 const selectRole = (role,index) => (event) => {

  event.preventDefault()

  if(!addNewUser.profile[index].gymInfo && props.isUserLookup) return new Toast({type:'warning',duration:3000,message:'Select Gym'})

  setAddNewUser(oldstate=>{

    let userRole = oldstate.profile[index].userRole || [];

    if(userRole.findIndex(d=>d.role == role.role)  == -1){
      userRole.push(role)
    }else{
      userRole.splice(userRole.findIndex(d=>d.role == role.role),1)
    }

    oldstate.profile[index].userRole=userRole

    return {
      ...oldstate
    }
  })

  setCurrentElementId("")

    event.stopPropagation()

}

  const handleChange = (name, value) => event => {
    value = !value ? event.target.value : value;
    setAddNewUser({
      ...addNewUser,
      [name]: value
    });
  }

  const getBranchParams = () => {
    let params = {
      pageNo,
      pageSize,
      isFilterByProfile:true
    };
    if (branchSearchKey) params.q = branchSearchKey;
    params.activationStatus = "active";
    return params;
  }
  
  const GetAllBranches = async (isReload) => {
    try {
      let params = getBranchParams();
      let branches = await getAllBranches(user._id, token, params);
      
      if(!branches.error){
        setAllBranches(isReload?branches:[...allBranches,...branches]);
      }

    } catch (error) {
    }
  }

    const GetBranchCount = async () => {
      try {
        let params = getBranchParams();
        let attr = await getBranchCount(user._id, token, params);
        pageNo.branch = 1;
        setPageNo({
          ...pageNo
        })
        pageCount.branch = Math.ceil(attr.COUNT / pageSize.branch);
        setPageCount({
          ...pageCount
        })
        total.branch = attr.COUNT;
        setTotal({
          ...total
        })
      } catch (error) {
        // do something
      }
    }


  const toggleInputFields = (id, index) => event => {
    setCurrentElementId(id);
    
    if(id == "user-dob") {
      openDateAndTime();
    }

    if(id == "anniversary-date") {
      openAnniversaryDateAndTime();
    }

    if (id == 'workout-gym-type') {
      setWorkoutGymTypeOpenDropdown(!workoutGymTypeOpenDropdown)
    } else {
      if (currentElementId == id) {
        setCurrentElementId('')
      } else {
        setCurrentElementId(id)
      }
    }
  };

  useEffect(()=>{
    if(currentElementId){
      setTimeout(() => {
        let element = document.querySelector("#"+currentElementId);
        if (element) {
          element.focus();
        }
        }, 100);
    }
  },[currentElementId]);



  const toggleAddNewUser = () => {
    if (isNewUser) {
      setNewUser(false)
    } else {
      setNewUser(true)
    }
  }


  const handleBranchScroll = async event => {

    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight))) {
        setBranchSpinnerLoader(true)
        pageNo = pageNo + 1;
        setPageNo(pageNo);
        await GetAllBranches();
        setBranchSpinnerLoader(false)
      }
    } catch (error) {
      setBranchSpinnerLoader(false)
    }
  }

  const SaveUser = async event => {
    event.preventDefault();
    try {
      await startLoader()
      setButtonLock(true)
      
      let payload = {
        name: addNewUser.name,
        email: addNewUser.email,
        gender:addNewUser.gender,
        phone: addNewUser.phone.substring(addNewUser.phone.length - 10,addNewUser.phone.length),
        profiles: addNewUser.profile.map(profile => ({ branchId: props.isUserLookup?profile?.gymInfo?._id:localStorage.getItem("branchId"), gymId:props.isUserLookup?profile?.gymInfo?.gymId:localStorage.getItem("gymId"), roles: profile.userRole.map(role => role.role) })),
        dateofbirth:addNewUser.dob,
        dateofbirthString:formatDateTime(addNewUser.dob),
      }

      if(addNewUser.gender) payload.gender = addNewUser.gender;
      if(addNewUser.password) payload.password = addNewUser.password;

      if(addNewUser.maritalStatus){
        payload.maritalStatus=addNewUser.maritalStatus;
        if(addNewUser.maritalStatus == "married"){
          payload.anniversaryDate = addNewUser.anniversaryDate;
          payload.anniversaryDateString = formatDateTime(new Date(addNewUser.anniversaryDate));
        }
      }

      const response = await updateUserV2(user._id, token, {
        userID: foundUser._id,
        UpdateBody: payload
      });

      setButtonLock(false);
      await stopLoader();

      if(response.error){
        new Toast({
          type:"error",
          message:response.error,
          duration:3000
        })
      }else{
        props.toggleAddUserModal();
        new Toast({
          type:"success",
          message:"Employee updated successfully",
          duration:3000
        })
        if (path == "/employees") history.push(`/employees`);
      }
    } catch (error) {
      await stopLoader()
      setButtonLock(false);
      new Toast({
        type:"error",
        message:"Server error, Unable to update user",
        duration:3000
      })
    }
  }

  const AddUser = async event => {
    event.preventDefault();
    try {
      await startLoader()
      setButtonLock(true);
      let payload = {
        name: addNewUser.name,
        email: addNewUser.email,
        phone: addNewUser.phone.substring(addNewUser.phone.length - 10,addNewUser.phone.length),
        gender:addNewUser.gender,
        profiles: addNewUser.profile.map(profile => ({ branchId: props.isUserLookup?profile?.gymInfo?._id:localStorage.getItem("branchId"), gymId:props.isUserLookup?profile?.gymInfo?.gymId:localStorage.getItem("gymId"), roles: profile.userRole.map(role => role.role) }))
      }
      if(addNewUser.password) payload.password = addNewUser.password;
      if(addNewUser.gender) payload.gender = addNewUser.gender;
      if(addNewUser.maritalStatus){
        payload.maritalStatus=addNewUser.maritalStatus;
        if(addNewUser.maritalStatus == "married"){
          payload.anniversaryDate = addNewUser.anniversaryDate;
          payload.anniversaryDateString = formatDateTime(new Date(addNewUser.anniversaryDate));
        }
      }

      const response = await createUserV2(user._id, token, payload);
      setButtonLock(false);
      await stopLoader();
      if(response.error){
        new Toast({
          type:"error",
          message:response.error,
          duration:3000
        })
      }else{
      new Toast({
        type:"success",
        message:"Employee created successfully",
        duration:3000
      })
      try {
        props.toggleAddUserModal?.();
        if (path == "/employees") history.push(`/employees`);
      } catch (closeErr) {
        console.error("Close modal failed:", closeErr);
      }
    }
    } catch (error) {
      console.error("AddUser failed:", error);
      // do something
      setButtonLock(false);
      stopLoader();
      new Toast({
        type:"error",
        message:"Server error, Unable to create user",
        duration:3000
      })
    }
  }


  useEffect(async () => {

    console.log(props.user);

    if (props.user && props.isEdit) {
      setUserEditEnabled(true);
      setAddNewUser(oldstate=>{

        let newstate = {
          ...oldstate,
          role: props.user.role,
          name: props.user.name,
          email: props.user.email,
          phone: props.user.phone,
          gender: props.user.gender,
          profile: [{
            ...userProfile
          }]
        }

        if(props.user.dateofbirth){
          newstate.dob = new Date(props.user.dateofbirth)
        }

        if(props?.user?.maritalStatus){
          newstate.maritalStatus=props?.user?.maritalStatus;
          if(newstate.maritalStatus == "married"){
            newstate.anniversaryDate = props?.user?.anniversaryDate;
            newstate.anniversaryDateString = formatDateTime(new Date(props?.user?.anniversaryDate));
          }
        }

        if(props?.user?.roleList?.length){
          newstate.profile[0].userRole = props.user.roleList;
        }

        return {...newstate}

      })
      setFoundUser(props.user);
      toggleAddNewUser()
      setButtonLock(false)
    } else {
      setUserEditEnabled(false);
      setAddNewUser({
        ...addNewUser,
        name: "",
        email: '',
        phone: "",
        profile:props.isUserLookup?[]:[{...userProfile}]
      })
      setButtonLock(true)
    }
  }, [props]);

  useEffect(async () => {
    await startLoader();
    try{
      if(props.isUserLookup){
        await GetBranchCount();
        await GetAllBranches(true);
      }
    }catch(err){
      console.log(err);
      await stopLoader();
    }
    await stopLoader();
  },[branchSearchKey]);



  
  useEffect(async () => {

    try{
      const roles = await getRoles(user._id,token);
      if(!roles.error) setRoles(roles.filter(role=>role.name != "member" && role.name != "workoutplus-admin"));
    }catch(error){

    }
  }, []);

  // <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{ borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : "", height: "100%", }}>
  //     <div className="modal-container d-flex flex-item" style={{width: window.innerWidth > 767 && "38%", height: window.innerWidth > 767 && "92%"}}>
  //       <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "90%" : "100%"}}>

  return (
    
        <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}> 
          <div className="modal-container d-flex flex-item" style={{height: window.innerWidth > 767 && "90%", width: window.innerWidth > 767 && "38%"}}>
            <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "90%" : "100%"}}>
          {
            window.innerWidth > 767 && (
              <div className="d-flex w-full space-between m-b-12" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
                <div className='d-flex'>
                  <svg className='flex-item m-r-12' width="36" height="36" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.475 9.04984C15.4356 9.07944 15.3908 9.10088 15.343 9.11312C15.2954 9.12536 15.2457 9.12808 15.197 9.12112C15.1482 9.11416 15.1013 9.0976 15.059 9.07256C15.0166 9.04744 14.9795 9.01424 14.95 8.97488C14.6366 8.55464 14.2292 8.2136 13.7603 7.97919C13.2914 7.74475 12.7742 7.6234 12.25 7.62487C12.1506 7.62487 12.0552 7.58536 11.9848 7.51503C11.9145 7.44471 11.875 7.34932 11.875 7.24987C11.875 7.15041 11.9145 7.05503 11.9848 6.98471C12.0552 6.91438 12.1506 6.87487 12.25 6.87487C12.5584 6.87527 12.8605 6.78792 13.1211 6.62302C13.3817 6.45812 13.5899 6.22247 13.7216 5.94361C13.8533 5.66475 13.9028 5.35419 13.8646 5.04819C13.8263 4.74219 13.7018 4.45341 13.5054 4.21557C13.3092 3.97772 13.0493 3.80063 12.7561 3.70499C12.463 3.60935 12.1486 3.59911 11.8498 3.67546C11.551 3.7518 11.2802 3.91159 11.0688 4.13615C10.8574 4.36071 10.7144 4.64077 10.6562 4.94362C10.6366 5.04192 10.579 5.12853 10.4959 5.18467C10.4129 5.24083 10.311 5.262 10.2125 5.24362C10.1642 5.23466 10.1182 5.21616 10.0773 5.1892C10.0362 5.16224 10.001 5.12736 9.97368 5.08662C9.94632 5.04587 9.92736 5.00007 9.91792 4.95191C9.90848 4.90374 9.9088 4.85418 9.91872 4.80612C10.0314 4.22739 10.3552 3.71124 10.8273 3.35806C11.2994 3.00487 11.886 2.83991 12.473 2.89526C13.0599 2.95061 13.6054 3.2223 14.0031 3.6575C14.4009 4.0927 14.6226 4.66029 14.625 5.24987C14.6262 5.61417 14.5427 5.97376 14.3811 6.30025C14.2195 6.62674 13.9842 6.91119 13.6938 7.13112C14.4325 7.40967 15.0764 7.89318 15.55 8.52488C15.6097 8.6044 15.6353 8.70448 15.6212 8.80288C15.6072 8.90136 15.5546 8.99016 15.475 9.04984ZM11.9375 13.3374C11.9788 13.4271 11.9837 13.5294 11.951 13.6227C11.9184 13.716 11.8508 13.793 11.7625 13.8374C11.7117 13.8615 11.6562 13.8743 11.6 13.8749C11.5291 13.8763 11.4594 13.857 11.3994 13.8192C11.3394 13.7814 11.2918 13.7269 11.2625 13.6624C10.9639 13.0514 10.4998 12.5366 9.92304 12.1766C9.34624 11.8164 8.68 11.6255 8 11.6255C7.32003 11.6255 6.65372 11.8164 6.07694 12.1766C5.50014 12.5366 5.03606 13.0514 4.7375 13.6624C4.69432 13.7518 4.61742 13.8205 4.52369 13.8533C4.42995 13.8861 4.32703 13.8803 4.2375 13.8374C4.14922 13.793 4.08162 13.716 4.04898 13.6227C4.01633 13.5294 4.02118 13.4271 4.0625 13.3374C4.54831 12.3364 5.39775 11.5585 6.4375 11.1624C5.91677 10.8252 5.51905 10.3287 5.30374 9.74688C5.08842 9.16512 5.06706 8.52928 5.24283 7.93439C5.41861 7.33947 5.7821 6.81735 6.27902 6.44602C6.77594 6.07467 7.37966 5.87403 8 5.87403C8.62032 5.87403 9.22408 6.07467 9.72096 6.44602C10.2179 6.81735 10.5814 7.33947 10.7572 7.93439C10.933 8.52928 10.9116 9.16512 10.6962 9.74688C10.481 10.3287 10.0832 10.8252 9.56248 11.1624C10.6022 11.5585 11.4517 12.3364 11.9375 13.3374ZM8 10.8749C8.42032 10.8749 8.83112 10.7502 9.18056 10.5167C9.53008 10.2833 9.8024 9.95136 9.96328 9.56304C10.1241 9.1748 10.1662 8.74752 10.0842 8.33528C10.0022 7.92309 9.79976 7.54445 9.50264 7.24727C9.20544 6.95008 8.8268 6.74769 8.41456 6.6657C8.00232 6.58371 7.57509 6.62579 7.1868 6.78663C6.7985 6.94746 6.46662 7.21983 6.23313 7.56928C5.99963 7.91874 5.875 8.3296 5.875 8.74984C5.87665 9.31296 6.10106 9.85248 6.49922 10.2506C6.89738 10.6488 7.43692 10.8732 8 10.8749ZM3.75 6.87487C3.44162 6.87527 3.1395 6.78792 2.87891 6.62302C2.61833 6.45812 2.41005 6.22247 2.2784 5.94361C2.14674 5.66475 2.09716 5.35419 2.13543 5.04819C2.1737 4.74219 2.29826 4.45341 2.49454 4.21557C2.69082 3.97772 2.95072 3.80063 3.2439 3.70499C3.53706 3.60935 3.8514 3.59911 4.15018 3.67546C4.44895 3.7518 4.71984 3.91159 4.93119 4.13615C5.14254 4.36071 5.28563 4.64077 5.34375 4.94362C5.36342 5.04192 5.42101 5.12853 5.50406 5.18467C5.58712 5.24083 5.68894 5.262 5.7875 5.24362C5.83575 5.23466 5.88174 5.21616 5.92275 5.1892C5.96376 5.16224 5.99898 5.12736 6.02634 5.08662C6.0537 5.04587 6.07265 5.00007 6.08208 4.95191C6.0915 4.90374 6.09122 4.85418 6.08125 4.80612C5.96863 4.22739 5.64478 3.71124 5.17269 3.35806C4.70059 3.00487 4.11401 2.83991 3.52703 2.89526C2.94005 2.95061 2.39464 3.2223 1.99688 3.6575C1.59912 4.0927 1.37746 4.66029 1.375 5.24987C1.37378 5.61417 1.45729 5.97376 1.6189 6.30025C1.78052 6.62674 2.01583 6.91119 2.30625 7.13112C1.56752 7.40967 0.923576 7.89318 0.45 8.52488C0.420453 8.56424 0.398954 8.60912 0.386732 8.6568C0.37451 8.70448 0.371805 8.75416 0.378769 8.80288C0.385734 8.85168 0.402232 8.89856 0.427322 8.94096C0.452413 8.98328 0.485603 9.02032 0.525 9.04984C0.564397 9.07944 0.609227 9.10088 0.656932 9.11312C0.704637 9.12536 0.754282 9.12808 0.803032 9.12112C0.851784 9.11416 0.898688 9.0976 0.941064 9.07256C0.983432 9.04744 1.02046 9.01424 1.05 8.97488C1.36335 8.55464 1.77079 8.2136 2.23966 7.97919C2.70853 7.74475 3.22579 7.6234 3.75 7.62487C3.84946 7.62487 3.94484 7.58536 4.01517 7.51503C4.08549 7.44471 4.125 7.34932 4.125 7.24987C4.125 7.15041 4.08549 7.05503 4.01517 6.98471C3.94484 6.91438 3.84946 6.87487 3.75 6.87487Z" fill="#ffffff"/>
                  </svg>
                  <p className="flex-item fs-20 font-weight-600 color-white m-t-3">{isUserEditEnabled ? "Edit" : "Add"} Employee</p>
                </div>
                <div onClick={props.toggleAddUserModal.bind(this)} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                  <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                  </svg>
                </div>
              </div>
            )
          }
          <div className="global-modal-scroll-container">
            <div className="w-full">
              {
                (isUserEditEnabled && foundUser) && (
                  <div className="w-full">
                    <div className="d-flex w-full p-b-16 m-b-16" style={{borderBottom: "1px dashed #b1b1b1"}}>
                      {
                        foundUser.profileID?(
                          <div className="d-flex branch-gym-logo m-r-8" style={{ background: "#f5f5f5" }}>
                            <img className="flex-item" src={`${client.config.API_URL}/image/file/${foundUser._id}/auto/auto/auto`} loading="lazy" />
                          </div>
                        ):(
                          <div className="d-flex branch-gym-logo m-r-8" style={{ background: "#5d883c" }}>
                            <p className="flex-item" style={{
                              color:"#ffffff",
                              fontSize:16,
                              fontWeight:600,
                              margin:'0 auto'
                            }}>{`${foundUser.name.trim()[0]}`.toUpperCase()}</p>
                          </div>
                        )
                      }
                      <div className="flex-item">
                        <p className="fs-16 font-weight-700 color-dark-blue">{foundUser.name}</p>
                        {/* <p className="fs-10 color-grey-02">{getUserRole(foundUser.role)}</p> */}
                      </div>
                      {
                        !props.isEdit && <svg onClick={toggleAddNewUser.bind(this)} className="m-l-12 flex-item cursor-pointer" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21.1678 8C20.389 6.21646 19.1068 4.69884 17.4784 3.63311C15.8499 2.56738 13.946 1.99983 11.9998 2C6.8148 2 2.5498 5.947 2.0498 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M16.9999 8H21.3999C21.4787 8 21.5567 7.98448 21.6295 7.95433C21.7023 7.92417 21.7684 7.87998 21.8241 7.82426C21.8798 7.76855 21.924 7.70241 21.9542 7.62961C21.9843 7.55681 21.9999 7.47879 21.9999 7.4V3M2.88086 16C4.42486 19.532 7.94886 22 12.0489 22C17.2349 22 21.4989 18.053 21.9999 13" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M7.0498 16H2.6498C2.49067 16 2.33806 16.0632 2.22554 16.1757C2.11302 16.2883 2.0498 16.4409 2.0498 16.6V21" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      }
                    </div>
                    <div className="d-flex w-full m-b-8">
                      <div className="d-flex" style={{ width: "20%" }}>
                        <svg className="flex-item m-r-6" width="14" height="14" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.74967 9.875H8.68592C1.31717 9.45125 0.270916 3.23375 0.124666 1.33625C0.112881 1.18872 0.130324 1.04031 0.175994 0.899529C0.221664 0.758749 0.294663 0.628364 0.39081 0.515845C0.486956 0.403325 0.60436 0.310883 0.736295 0.243815C0.868229 0.176747 1.0121 0.136371 1.15967 0.125H3.22592C3.37612 0.124855 3.52292 0.169816 3.64728 0.254061C3.77164 0.338306 3.86784 0.457951 3.92342 0.5975L4.49342 2C4.5483 2.13633 4.56192 2.28578 4.53258 2.42978C4.50325 2.57379 4.43225 2.706 4.32842 2.81L3.52967 3.61625C3.65443 4.32528 3.99398 4.97888 4.50238 5.48861C5.01077 5.99834 5.66347 6.33961 6.37217 6.46625L7.18592 5.66C7.29148 5.55731 7.42494 5.48797 7.56965 5.46063C7.71436 5.43329 7.86391 5.44915 7.99967 5.50625L9.41342 6.0725C9.55086 6.12983 9.66813 6.22678 9.75027 6.351C9.83241 6.47522 9.87572 6.62108 9.87467 6.77V8.75C9.87467 9.04837 9.75614 9.33452 9.54516 9.5455C9.33418 9.75647 9.04803 9.875 8.74967 9.875ZM1.24967 0.875C1.15021 0.875 1.05483 0.914509 0.984501 0.984835C0.914174 1.05516 0.874666 1.15054 0.874666 1.25V1.28C1.04717 3.5 2.15342 8.75 8.72717 9.125C8.77643 9.12804 8.82581 9.12133 8.87248 9.10525C8.91914 9.08917 8.96218 9.06403 8.99911 9.03128C9.03604 8.99854 9.06614 8.95882 9.08768 8.91441C9.10923 8.87 9.1218 8.82178 9.12467 8.7725V6.77L7.71092 6.20375L6.63467 7.2725L6.45467 7.25C3.19217 6.84125 2.74967 3.57875 2.74967 3.545L2.72717 3.365L3.79217 2.28875L3.22967 0.875H1.24967Z" fill="var(--darkBlue)" />
                        </svg>
                        <p className="flex-item fs-14 font-weight-500 color-dark-blue">Phone</p>
                      </div>
                      <p className="branch-gym-details-value font-weight-600">+91 {foundUser.phone}</p>
                    </div>
                    <div className="d-flex w-full m-b-20">
                      <div className="d-flex" style={{ width: "20%" }}>
                        <svg className="flex-item m-r-6" width="14" height="14" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.75 0H0.75C0.551088 0 0.360322 0.0790176 0.21967 0.21967C0.0790176 0.360322 0 0.551088 0 0.75V6.75C0 6.94891 0.0790176 7.13968 0.21967 7.28033C0.360322 7.42098 0.551088 7.5 0.75 7.5H9.75C9.94891 7.5 10.1397 7.42098 10.2803 7.28033C10.421 7.13968 10.5 6.94891 10.5 6.75V0.75C10.5 0.551088 10.421 0.360322 10.2803 0.21967C10.1397 0.0790176 9.94891 0 9.75 0V0ZM8.925 0.75L5.25 3.2925L1.575 0.75H8.925ZM0.75 6.75V1.09125L5.03625 4.0575C5.09902 4.10105 5.1736 4.12438 5.25 4.12438C5.3264 4.12438 5.40098 4.10105 5.46375 4.0575L9.75 1.09125V6.75H0.75Z" fill="var(--darkBlue)" />
                        </svg>
                        <p className="flex-item fs-14 font-weight-500 color-dark-blue">Email</p>
                      </div>
                      <p className="branch-gym-details-value font-weight-600">{foundUser.email ? foundUser.email : "N.A."}</p>
                    </div>
                  </div>
                )
              }

              <div className="w-full">
                <div className="d-flex-wrap space-between">

                  <div onClick={toggleInputFields('user-name')} className={`${currentElementId == "user-name" || addNewUser.name ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == "user-name" || addNewUser.name ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && "48.5%" }}>
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-8" width={currentElementId == "user-name" || addNewUser.name ? "12" : "18"} height={currentElementId == "user-name" || addNewUser.name ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 5.15C4.9528 5.15 4.1 4.2972 4.1 3.25C4.1 2.2028 4.9528 1.35 6 1.35C7.0472 1.35 7.9 2.2028 7.9 3.25C7.9 4.2972 7.0472 5.15 6 5.15ZM10.15 10V10.15H10H1.85V10C1.85 8.26377 3.26333 6.85 5 6.85H7C8.7362 6.85 10.15 8.2638 10.15 10Z" stroke={currentElementId == "user-name" || addNewUser.name ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="0.7" />
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "user-name" || addNewUser.name ? "10px" : "14px", color: currentElementId == "user-name" || addNewUser.name ? "var(--darkBlue)" : "", transition: "180ms" }}>Name*</p>
                    </div>
                    <input id="user-name" onChange={handleChange('name')} value={addNewUser.name} className={`${currentElementId == "user-name" || addNewUser.name ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>

                  <div onClick={toggleInputFields('user-phone')} className={`${currentElementId == "user-phone" || addNewUser.phone ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == "user-phone" || addNewUser.phone ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && "48.5%" }}>
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-12" width={currentElementId == "user-phone" || addNewUser.phone ? "12" : "16"} height={currentElementId == "user-phone" || addNewUser.phone ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.74967 9.875H8.68592C1.31717 9.45125 0.270916 3.23375 0.124666 1.33625C0.112881 1.18872 0.130324 1.04031 0.175994 0.899529C0.221664 0.758749 0.294663 0.628364 0.39081 0.515845C0.486956 0.403325 0.60436 0.310883 0.736295 0.243815C0.868229 0.176747 1.0121 0.136371 1.15967 0.125H3.22592C3.37612 0.124855 3.52292 0.169816 3.64728 0.254061C3.77164 0.338306 3.86784 0.457951 3.92342 0.5975L4.49342 2C4.5483 2.13633 4.56192 2.28578 4.53258 2.42978C4.50325 2.57379 4.43225 2.706 4.32842 2.81L3.52967 3.61625C3.65443 4.32528 3.99398 4.97888 4.50238 5.48861C5.01077 5.99834 5.66347 6.33961 6.37217 6.46625L7.18592 5.66C7.29148 5.55731 7.42494 5.48797 7.56965 5.46063C7.71436 5.43329 7.86391 5.44915 7.99967 5.50625L9.41342 6.0725C9.55086 6.12983 9.66813 6.22678 9.75027 6.351C9.83241 6.47522 9.87572 6.62108 9.87467 6.77V8.75C9.87467 9.04837 9.75614 9.33452 9.54516 9.5455C9.33418 9.75647 9.04803 9.875 8.74967 9.875ZM1.24967 0.875C1.15021 0.875 1.05483 0.914509 0.984501 0.984835C0.914174 1.05516 0.874666 1.15054 0.874666 1.25V1.28C1.04717 3.5 2.15342 8.75 8.72717 9.125C8.77643 9.12805 8.82581 9.12133 8.87248 9.10525C8.91914 9.08917 8.96218 9.06403 8.99911 9.03128C9.03604 8.99854 9.06614 8.95882 9.08768 8.91441C9.10923 8.87 9.1218 8.82178 9.12467 8.7725V6.77L7.71092 6.20375L6.63467 7.2725L6.45467 7.25C3.19217 6.84125 2.74967 3.57875 2.74967 3.545L2.72717 3.365L3.79217 2.28875L3.22967 0.875H1.24967Z" fill={currentElementId == "user-phone" || addNewUser.phone ? "var(--darkBlue)" : "#6d6d6d"} />
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "user-phone" || addNewUser.phone ? "10px" : "14px", color: currentElementId == "user-phone" || addNewUser.phone ? "var(--darkBlue)" : "", transition: "180ms" }}>Phone*</p>
                    </div>
                    <input id="user-phone" onChange={handleChange('phone')} value={addNewUser.phone} className={`${currentElementId == "user-phone" || addNewUser.phone ? "active-input-field" : "inactive-input-field"}`} type="number" />
                  </div>

                  <div onClick={toggleInputFields('user-email')} className={`${currentElementId == "user-email" || addNewUser.email ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == "user-email" || addNewUser.email ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && "48.5%" }}>
                    <div className="flex-item d-flex">
                      <svg className="flex-item m-r-8" width={currentElementId == "user-email" || addNewUser.email ? "12" : "18"} height={currentElementId == "user-email" || addNewUser.email ? "12" : "18"}  style={{ transition: "180ms" }} viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.51 1H3.46999C2.10585 1 1 2.10586 1 3.47V13.41C1 14.7741 2.10585 15.88 3.46999 15.88H17.51C18.8741 15.88 19.98 14.7741 19.98 13.41V3.47C19.98 2.10586 18.8741 1 17.51 1Z" stroke={currentElementId == "user-email" || addNewUser.email ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="1.5" stroke-miterlimit="10"/>
                        <path d="M2.10938 2.20996L10.4894 10.49L18.7994 2.25996" stroke={currentElementId == "user-email" || addNewUser.email ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.08008 14.6799L8.28008 9.11987" stroke={currentElementId == "user-email" || addNewUser.email ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.9702 14.63L12.6602 9" stroke={currentElementId == "user-email" || addNewUser.email ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "user-email" || addNewUser.email ? "10px" : "14px", color: currentElementId == "user-email" || addNewUser.email ? "var(--darkBlue)" : "", transition: "180ms" }}>Email (Optional)</p>
                    </div>
                    <input id="user-email" onChange={handleChange('email')} value={addNewUser.email} className={`${currentElementId == "user-email" || addNewUser.email ? "active-input-field" : "inactive-input-field"}`} type="text" />
                  </div>

                  <div onClick={toggleInputFields('user-gender')} className={`${(currentElementId == "user-gender" || addNewUser.gender) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "user-gender" || addNewUser.gender) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && "48.5%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "user-gender" || addNewUser.gender) ? "10px" : "14px", color: (currentElementId == "user-gender" || addNewUser.gender) ? "var(--darkBlue)" : "", transition: "180ms" }}>Gender</p>
                    </div>
                    <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                      <svg className="flex-item" style={{ transform: workoutGymTypeOpenDropdown ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                      </svg>
                    </div>
                    <input id="user-gender" className={`${(currentElementId == "user-gender" || addNewUser.gender) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gender" value={addNewUser.gender} style={{ pointerEvents: "none",textTransform:'capitalize' }} />
                    {
                      currentElementId == "user-gender" && (
                        <div onClick={(e)=>e.stopPropagation()} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                          <div onClick={getSelectedGender.bind(this, "Male")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Male</p>
                          </div>
                          <div onClick={getSelectedGender.bind(this, "Female")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Female</p>
                          </div>
                          <div onClick={getSelectedGender.bind(this, "Other")} className="global-input-field-arrow-dropdown-item">
                            <p className="flex-item">Others</p>
                          </div>
                        </div>
                      )
                    }
                  </div>

                  <div onClick={toggleInputFields("user-dob")} className={`${currentElementId == "user-dob" || addNewUser.dob ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "user-dob" || addNewUser.dob) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && "48.5%"}}>
                    <div className="flex-item d-flex" style={{marginTop: (currentElementId == "user-dob" || addNewUser.dob) ? "4px" : ""}}>
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "user-dob" || addNewUser.dob) ? "12px" : "16px", lineHeight: (currentElementId == "user-dob" || addNewUser.dob) ? "12px" : "14px", color: (currentElementId == "user-dob" || addNewUser.dob) ? "var(--darkBlue)" : "", transition: "180ms" }}>Date of Birth</p>
                    </div>
                    <input id="user-dob" ref={birthDateRef} readOnly value={addNewUser.dob ?  formatDate(new Date(addNewUser.dob)) : ""} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'planner-start-date' || addNewUser.dob) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder='YYYY-MM-DD' />
                  </div>

                  {
                    (user.role == 0 || user.role == 1) && (
                      <div onClick={toggleInputFields('user-password')} className={`${currentElementId == "user-password" || addNewUser.password ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: currentElementId == "user-password" || addNewUser.password ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && "48.5%" }}>
                        <div className="flex-item d-flex">
                          <svg className="flex-item m-r-6" width={currentElementId == "user-password" || addNewUser.password ? "12" : "18"} height={currentElementId == "user-password" || addNewUser.password ? "12" : "18"}  style={{ transition: "180ms" }} viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.81811 12.1581V9.26521C5.76374 8.11796 5.94276 6.9716 6.34433 5.89554C6.7459 4.81949 7.36171 3.83612 8.15439 3.00498C8.94708 2.17384 9.90019 1.51221 10.956 1.06015C12.0119 0.608086 13.1485 0.375 14.297 0.375C15.4456 0.375 16.5822 0.608086 17.638 1.06015C18.6938 1.51221 19.6469 2.17384 20.4396 3.00498C21.2323 3.83612 21.8481 4.81949 22.2496 5.89554C22.6512 6.9716 22.8302 8.11796 22.7759 9.26521V12.1581" stroke={currentElementId == "user-password" || addNewUser.password ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M23.2518 12.1587H5.34239C2.59896 12.1587 0.375 14.3827 0.375 17.1261V29.0784C0.375 31.8218 2.59896 34.0458 5.34239 34.0458H23.2518C25.9952 34.0458 28.2192 31.8218 28.2192 29.0784V17.1261C28.2192 14.3827 25.9952 12.1587 23.2518 12.1587Z" stroke={currentElementId == "user-password" || addNewUser.password ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.7644 24.4153C12.385 24.1002 12.112 23.6758 11.9825 23.1999C11.8531 22.724 11.8735 22.2198 12.041 21.756C12.2085 21.2921 12.5149 20.8912 12.9185 20.6078C13.3221 20.3244 13.8034 20.1724 14.2965 20.1724C14.7897 20.1724 15.2708 20.3244 15.6745 20.6078C16.0781 20.8912 16.3845 21.2921 16.552 21.756C16.7195 22.2198 16.74 22.724 16.6105 23.1999C16.481 23.6758 16.208 24.1002 15.8286 24.4153" stroke={currentElementId == "user-password" || addNewUser.password ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.8276 24.4155C15.8379 24.5295 15.8379 24.6441 15.8276 24.7581V27.08C15.8519 27.3008 15.8295 27.5241 15.7616 27.7356C15.6938 27.947 15.5822 28.1418 15.434 28.3072C15.2858 28.4726 15.1045 28.6049 14.9017 28.6955C14.699 28.786 14.4794 28.8329 14.2574 28.8329C14.0353 28.8329 13.8158 28.786 13.6131 28.6955C13.4103 28.6049 13.2289 28.4726 13.0808 28.3072C12.9326 28.1418 12.821 27.947 12.7532 27.7356C12.6854 27.5241 12.6629 27.3008 12.6873 27.08V24.7581C12.677 24.6441 12.677 24.5295 12.6873 24.4155" stroke={currentElementId == "user-password" || addNewUser.password ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <p className="flex-item m-t-2" style={{ fontSize: currentElementId == "user-password" || addNewUser.password ? "10px" : "14px", color: currentElementId == "user-password" || addNewUser.password ? "var(--darkBlue)" : "", transition: "180ms" }}>Set Password</p>
                        </div>         
                          <input id="user-password" onChange={handleChange('password')} value={addNewUser.password} className={`${currentElementId == "user-password" || addNewUser.password ? "active-input-field" : "inactive-input-field"}`} type={isPasswordVisible ? "text" : "password"} />
                          {
                            (currentElementId == "user-password" || addNewUser.password) && (
                              <div onClick={()=>togglePasswordVisibility()} className='d-flex cursor-pointer' style={{position:"absolute", top:0, right:0, margin:"12px 12px 0 0"}}>
                                {
                                  isPasswordVisible ? (
                                    <svg className='flex-item margin-auto' width="20" height="20" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.02504 6.602C1.73081 3.327 4.6812 1 8 1C11.3188 1 14.2682 3.327 14.975 6.602C15.003 6.73196 15.0832 6.84584 15.1981 6.91861C15.313 6.99137 15.4531 7.01705 15.5876 6.99C15.7221 6.96295 15.8399 6.88538 15.9152 6.77436C15.9905 6.66334 16.0171 6.52796 15.9891 6.398C15.185 2.673 11.8217 0 8 0C4.17826 0 0.814959 2.673 0.0108719 6.398C-0.0171232 6.52796 0.0094528 6.66334 0.0847536 6.77436C0.160054 6.88538 0.277912 6.96295 0.412398 6.99C0.546885 7.01705 0.686984 6.99137 0.801876 6.91861C0.916768 6.84584 0.997041 6.73196 1.02504 6.602ZM7.98965 3C8.95027 3 9.87154 3.36875 10.5508 4.02513C11.2301 4.6815 11.6117 5.57174 11.6117 6.5C11.6117 7.42826 11.2301 8.3185 10.5508 8.97487C9.87154 9.63125 8.95027 10 7.98965 10C7.02903 10 6.10776 9.63125 5.4285 8.97487C4.74924 8.3185 4.36764 7.42826 4.36764 6.5C4.36764 5.57174 4.74924 4.6815 5.4285 4.02513C6.10776 3.36875 7.02903 3 7.98965 3Z" fill="var(--darkBlue)"/>
                                    </svg>
                                  ) : (
                                    <svg className='flex-item margin-auto' width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M0.854511 0.14662C0.808029 0.100136 0.752848 0.0632624 0.692117 0.0381053C0.631386 0.0129482 0.566295 4.89791e-10 0.500561 0C0.434826 -4.89792e-10 0.369735 0.0129482 0.309004 0.0381053C0.248274 0.0632624 0.193092 0.100136 0.146611 0.14662C0.100129 0.193104 0.0632585 0.248289 0.038103 0.309024C0.0129474 0.369758 -4.89761e-10 0.434853 0 0.500592C4.89761e-10 0.566331 0.0129474 0.631426 0.038103 0.69216C0.0632585 0.752895 0.100129 0.80808 0.146611 0.854564L3.64612 4.35229C1.91316 5.53475 0.706634 7.34358 0.280592 9.39789C0.267199 9.46217 0.266597 9.52845 0.278819 9.59296C0.291042 9.65747 0.315851 9.71894 0.351828 9.77386C0.387806 9.82879 0.434248 9.87608 0.488503 9.91305C0.542759 9.95003 0.603764 9.97595 0.668037 9.98934C0.73231 10.0027 0.798592 10.0033 0.863097 9.99112C0.927603 9.97889 0.98907 9.95408 1.04399 9.9181C1.09891 9.88212 1.1462 9.83568 1.18317 9.78142C1.22014 9.72716 1.24606 9.66615 1.25945 9.60187C1.45084 8.67863 1.82421 7.80276 2.35776 7.02539C2.89131 6.24803 3.57435 5.58473 4.36701 5.07423L5.94979 6.65611C5.53728 6.95201 5.19408 7.33413 4.944 7.77595C4.69393 8.21777 4.54297 8.70871 4.5016 9.21471C4.46023 9.72071 4.52943 10.2297 4.70442 10.7062C4.8794 11.1828 5.15597 11.6156 5.51494 11.9746C5.87391 12.3336 6.30668 12.6102 6.78323 12.7852C7.25977 12.9602 7.76869 13.0294 8.27466 12.988C8.78063 12.9466 9.27154 12.7957 9.71333 12.5456C10.1551 12.2955 10.5372 11.9523 10.8331 11.5397L15.1455 15.8534C15.2394 15.9473 15.3667 16 15.4994 16C15.6322 16 15.7595 15.9473 15.8534 15.8534C15.9473 15.7595 16 15.6322 16 15.4994C16 15.3666 15.9473 15.2393 15.8534 15.1454L0.854511 0.14662ZM8.12348 6.00316L11.486 9.36589C11.4521 8.48486 11.087 7.64907 10.4636 7.02562C9.8402 6.40218 9.00446 6.03702 8.12348 6.00316ZM5.52985 3.41036L6.33274 4.2133C6.87698 4.07157 7.43711 3.99999 7.9995 4.00032C11.205 4.00032 14.0556 6.32713 14.7385 9.60187C14.7656 9.73182 14.8432 9.8457 14.9542 9.91846C15.0652 9.99121 15.2005 10.0169 15.3305 9.98984C15.4604 9.96279 15.5743 9.88523 15.647 9.77422C15.7198 9.66321 15.7455 9.52783 15.7184 9.39789C14.9415 5.67318 11.692 3.00039 7.9995 3.00039C7.14462 3.00039 6.31174 3.14338 5.52985 3.41036Z" fill="var(--darkBlue)"/>
                                    </svg>
                                  )
                                }
                              </div>
                            )
                          }
                      </div>
                    )
                  }
                </div>

                <p className="flex-item fs-16 color-dark-blue font-weight-700 m-b-4 m-t-8">Marital Status</p>

                <div className="d-flex flex-item m-b-12">
                  <div onClick={()=>handleMaritalStatus("single")} className="flex-item d-flex m-r-20">
                    <input className="flex-item m-r-8" type="radio" name="marital-status" checked={addNewUser.maritalStatus == "single"} style={{width:"20px", height:"20px"}}/>
                    <p className="flex-item">Single</p>
                  </div>
                  <div onClick={()=>handleMaritalStatus("married")} className="flex-item d-flex">
                    <input className="flex-item m-r-8" type="radio" name="marital-status" checked={addNewUser.maritalStatus == "married"} style={{width:"20px", height:"20px"}} />
                    <p className="flex-item">Married</p>
                  </div>
                </div>

                {
                  addNewUser.maritalStatus == "married" && (
                    <div onClick={toggleInputFields("anniversary-date")} className={`${currentElementId == "anniversary-date" || addNewUser.anniversaryDate ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "anniversary-date" || addNewUser.anniversaryDate) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 && "48.5%"}}>
                      <div className="flex-item d-flex" style={{marginTop: (currentElementId == "anniversary-date" || addNewUser.anniversaryDate) ? "4px" : ""}}>
                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "anniversary-date" || addNewUser.anniversaryDate) ? "12px" : "16px", lineHeight: (currentElementId == "anniversary-date" || addNewUser.anniversaryDate) ? "12px" : "14px", color: (currentElementId == "anniversary-date" || addNewUser.anniversaryDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Anniversary Date <span className="color-red font-weight-600">*</span></p>
                      </div>
                      <input id="anniversary-date" ref={anniversaryDateRef} readOnly value={addNewUser.anniversaryDate ?  formatDate(new Date(addNewUser.anniversaryDate)) : ""} style={{color: "#2b2b2b", pointerEvents:"none"}} className={`${(currentElementId == 'anniversary-date' || addNewUser.anniversaryDate) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder='YYYY-MM-DD' />
                    </div>
                  )  
                }

                <p className="flex-item fs-16 color-dark-blue font-weight-700 m-b-12 m-t-8">{props.isUserLookup?"Employee Profile":props.isEdit?"Edit Role(s)*":"Assign Role(s)*"}</p>
                {
                  props.isUserLookup && (
                    <div onClick={handleWpAdminChange} className="d-flex m-b-16">
                        <input style={{height:'20px',width:'20px'}} className='flex-item m-r-8' type='checkbox' checked={isWpAdmin} name="wp"/>
                        <p className="flex-item color-grey-02 fs-16" style={{color:isWpAdmin && '#E33A34'}}>Workoutplus Admin</p>
                    </div>

                  )
                }
                {
                  addNewUser.profile.map((userProfile, index) => {
                    return(
                      <div className="user-gym-profile-container w-full m-b-20" style={{paddingBottom:"0px", boxShadow:"0px 0px 4px rgba(0,0,0,0.25)"}}>

                        {
                          props.isUserLookup && (
                            <div onClick={()=>handleDeleteProfile(index)} style={{position:"relative"}}>
                              <div className="table-action-btn red-btn d-flex cursor-pointer" style={{position:"absolute", top:0, right:0, margin:"-20px -16px 0 0", boxShadow:"0px 0px 12px rgba(0,0,0,0.25)"}}>
                                <svg className="svg-stroke flex-item margin-auto" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M0.75 13.75L13.75 0.75M13.75 13.75L0.75 0.75" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                            </div>
                          )
                        }

                        {props.isUserLookup && <div onClick={toggleInputFields("select-gym"+index)} className={`${(currentElementId == "select-gym"+index || userProfile.gymInfo.name) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "select-gym"+index || userProfile.gymInfo.name) ? "1px solid var(--darkBlue)" : "", width:"94%" }}>
                          <div className="flex-item d-flex">
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "select-gym"+index || userProfile.gymInfo.name) ? "10px" : "14px", color: (currentElementId == "select-gym"+index || userProfile.gymInfo.name) ? "var(--darkBlue)" : "", transition: "180ms" }}>Select Gym</p>
                          </div>
                          <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                            <svg className="flex-item" style={{ transform: currentElementId == "select-gym"+index ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                            </svg>
                          </div>
                          <input id={"select-gym"+index} className={`${(currentElementId == "select-gym"+index || userProfile.gymInfo.name) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gym" value={userProfile.gymInfo.name} style={{ pointerEvents: "none",textTransform:'capitalize' }} />

                          {
                            currentElementId == "select-gym"+index && [
                              <div onClick={(e)=>e.stopPropagation()} className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                <div className="w-full" style={{padding:"12px 0px 12px 0px", top:0, position:"sticky", left: 0, right: 0, background:"#ffffff"}}>
                                  <div id="search-container" className='global-search-box' style={{width:"100%"}}>
                                    <svg id="search-icon" className='flex-item m-b-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_1637_1318)">
                                        <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1637_1318">
                                          <rect width="16" height="16" fill="white" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                    <input id="search-branch-input" className='flex-item' type="text" placeholder="Search Branch by Name" onChange={_.debounce(handleSearchBranch,1000)} />
                                  </div>
                                </div>
                                {/* selectedBranches */}
                                <div style={{overflowY:'auto',minHeight:300,maxHeight:400}} onScroll={handleBranchScroll}>
                                  {
                                    allBranches.length > 0 && allBranches.map(branchInfo => {
                                      return(
                                        <div onClick={()=>handleSelectProfile(branchInfo,index)} className="global-input-field-arrow-dropdown-item" style={{padding:"12px", borderBottom:"1px solid #f5f5f5"}}>
                                          <p className="flex-item">{branchInfo.name}</p>
                                          <div className="d-flex m-t-4">
                                            <svg className="flex-item m-r-4" width="14" height="14" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M5 6.72917C4.5264 6.72917 4.0722 6.5426 3.73731 6.2105C3.40242 5.87841 3.21429 5.42799 3.21429 4.95833C3.21429 4.48868 3.40242 4.03826 3.73731 3.70617C4.0722 3.37407 4.5264 3.1875 5 3.1875C5.4736 3.1875 5.9278 3.37407 6.26269 3.70617C6.59758 4.03826 6.78571 4.48868 6.78571 4.95833C6.78571 5.19088 6.73953 5.42115 6.64979 5.636C6.56004 5.85085 6.42851 6.04606 6.26269 6.2105C6.09687 6.37494 5.90002 6.50538 5.68336 6.59437C5.46671 6.68336 5.2345 6.72917 5 6.72917ZM5 0C3.67392 0 2.40215 0.522394 1.46447 1.45226C0.526784 2.38213 0 3.6433 0 4.95833C0 8.67708 5 14.1667 5 14.1667C5 14.1667 10 8.67708 10 4.95833C10 3.6433 9.47322 2.38213 8.53553 1.45226C7.59785 0.522394 6.32608 0 5 0Z" fill="#CC0000"/>
                                            </svg>
                                            <p className="flex-item" style={{fontSize:"12px", color:"#6d6d6d"}}>{branchInfo.address}</p>
                                          </div>
                                        </div>
                                      )
                                    })
                                  }
                                  {isBranchSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                              </div>
                              </div>
                            ]
                          }
                          
                        </div>}
                        {props.isUserLookup && <p className="color-red font-weight-600 m-t-12 m-b-8 fs-16">Selected Role(s)</p>}
                        <div className="d-flex-wrap">
                          {
                            roles.map(role => {
                                return (
                                  <div onClick={selectRole(role,index)} className="member-button-global d-flex m-r-12 m-b-12" style={{background: userProfile.userRole.findIndex(d=>d.role == role.role)!=-1 ? "#E33A34" : "#e0e0e0", height:"26px", boxShadow:"none"}}>
                                    <p className="flex-item" style={{color: userProfile.userRole.findIndex(d=>d.role == role.role)!=-1 && "#ffffff"}}>{client.config.roleNames[role.name]}</p>
                                  </div>
                                )
                            })
                          }
                        </div>
                      </div>
                    )
                  })
                }

               {props.isUserLookup&&<div className="d-flex">
                  <div onClick={()=>handleAddProfile()} className="member-button-global d-flex m-r-12 m-b-12">
                    <p className="flex-item">Add More Profile</p>
                  </div>
                </div>}
              

              </div>
            </div>
            <div className="bottom-action-button">
              <div onClick={(isButtonLock) ? null : props.isEdit ? SaveUser : AddUser}  className={`member-button-global btn-center d-flex ${(isButtonLock) ? "member-button-global-inactive" : ""}`} >
                <p className="flex-item">{props.isEdit ? "Edit" : "Add"}</p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManageEmployeeModal;